module.exports = __webpack_public_path__ + "static/media/loginLogo.1f241044.png";